import React, { useState, useEffect } from 'react';
import styles from './UserDetails.module.css';
import Input from '../shared/Input';
import ReCAPTCHA from 'react-google-recaptcha';
import FormButton from '../shared/FormButton';
import { useDispatch, useSelector } from 'react-redux';

import { defaultRegisterForm } from '../../../data/defaultForms';
import { defaultRegisterFormState } from '../../../data/defaultFormStates';
import { selectSendingDetails } from '../../../store/selectors';
import { sendUserDetailsForm } from '../../../store';
import Image from '../../../../../components/elements/Image';
import FormValidator from '@deadlinefunnel/form-validator';

const useFormValidator = (form, fieldsState) => {
  const [innerFieldsState, setInnerFieldsState] = useState(fieldsState);

  const formValidator = new FormValidator(form, innerFieldsState);

  useEffect(() => {
    setInnerFieldsState(formValidator.validate());
    // eslint-disable-next-line
  }, [form]);

  return { fields: innerFieldsState, isValid: formValidator.isValid() };
};

const UserDetails = ({ funnel }) => {
  const [isFirstRun, setIsFirstRun] = useState(true);
  const [registerForm, setRegisterForm] = useState({ ...defaultRegisterForm, funnel });

  const registerFormState = useFormValidator(registerForm, defaultRegisterFormState);
  const sendingUserDetailsForm = useSelector(selectSendingDetails);

  const dispatch = useDispatch();

  const sendUserDetailsFormAttempt = (e) => {
    e.preventDefault();
    setIsFirstRun(false);
    if (registerFormState.isValid) {
      dispatch(sendUserDetailsForm(registerForm));
    }
  };

  return (
    <div className={styles.userForm}>
      <div className={styles.accountContainer}>
        <h3 className={styles.rightTitle}>1. Create Your Account</h3>
        {funnel === 'cc' && (
          <div className="d-flex align-items-center">
            <div className={styles.stepText}>Step 1 of 2</div>
            <Image name="step-one-gauge" className={styles.stepOneImage} />
          </div>
        )}
      </div>

      <div className={styles.formContainer}>
        <h3 className={styles.rightTitleMobile}>1. Create Your Account</h3>
        <form onSubmit={sendUserDetailsFormAttempt}>
          <div className={styles.formgroup}>
            <label htmlFor="email">Email</label>
            <Input
              cySelector="email"
              value={registerForm.email}
              onChange={(value) => setRegisterForm({ ...registerForm, email: value })}
              isInvalid={!isFirstRun && !registerFormState.fields.email.valid}
              errorText={registerFormState.fields.email.error}
              placeholder="Email"
              id="email"
            />
          </div>
          <div className="row">
            <div className="col-6">
              <div className={styles.formgroup}>
                <label htmlFor="password">Password</label>
                <Input
                  cySelector="password"
                  type="password"
                  value={registerForm.password}
                  onChange={(value) => setRegisterForm({ ...registerForm, password: value })}
                  isInvalid={!isFirstRun && !registerFormState.fields.password.valid}
                  errorText={registerFormState.fields.password.error}
                  placeholder="Password"
                  id="password"
                />
              </div>
            </div>
            <div className="col-6">
              <div className={styles.formgroup}>
                <label htmlFor="password-confirm">Confirm Password</label>
                <Input
                  cySelector="password-confirm"
                  type="password"
                  value={registerForm.password_confirm}
                  onChange={(value) => setRegisterForm({ ...registerForm, password_confirm: value })}
                  isInvalid={!isFirstRun && !registerFormState.fields.password_confirm.valid}
                  errorText={registerFormState.fields.password_confirm.error}
                  placeholder="Confirm your password"
                  id="password-confirm"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className={styles.formgroup}>
                <label htmlFor="first-name">First Name</label>
                <Input
                  cySelector="first-name"
                  value={registerForm.first_name}
                  onChange={(value) => setRegisterForm({ ...registerForm, first_name: value })}
                  isInvalid={!isFirstRun && !registerFormState.fields.first_name.valid}
                  errorText={registerFormState.fields.first_name.error}
                  placeholder="First name"
                  id="first-name"
                />
              </div>
            </div>
            <div className="col-6">
              <div className={styles.formgroup}>
                <label htmlFor="last-name">Last Name</label>
                <Input
                  cySelector="last-name"
                  value={registerForm.last_name}
                  onChange={(value) => setRegisterForm({ ...registerForm, last_name: value })}
                  isInvalid={!isFirstRun && !registerFormState.fields.last_name.valid}
                  errorText={registerFormState.fields.last_name.error}
                  placeholder="Last name"
                  id="last-name"
                />
              </div>
            </div>
          </div>
          <div className={`${styles.recaptcha} d-flex justify-content-center`}>
            <ReCAPTCHA
              sitekey={process.env.NOCAPTCHA_SITEKEY}
              onChange={(value) => setRegisterForm({ ...registerForm, 'g-recaptcha-response': value })}
            />
          </div>
          <FormButton
            submitting={sendingUserDetailsForm}
            submittingText={funnel == 'cc' ? 'Loading next step...' : 'Creating your account...'}
            className={styles.formButton}
          >
            {funnel == 'cc' ? 'Continue' : 'Start Boosting Sales Now!'}
          </FormButton>
        </form>
      </div>
    </div>
  );
};

export default UserDetails;
